import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import { fetchSliderServices } from '../api/SliderApi'; // Adjust the import if needed
import { useTranslation } from "react-i18next";


const Sponsors = () => {
  
      const { t } = useTranslation("home"); // Hook to use translations
  
  const [sponsors, setSponsors] = useState([]); // State to store fetched sponsors data

  useEffect(() => {
    // Fetch the slider data when the component mounts
    const getSponsors = async () => {
      try {
        const response = await fetchSliderServices(); // Fetch data from the API
        setSponsors(response.data); // Access the 'data' field in the response
      } catch (error) {
        console.error("Error fetching sponsors:", error);
      }
    };

    getSponsors(); // Call the function to fetch data
  }, []); // Empty dependency array ensures this effect runs once when the component mounts

  return (
    <div className="relative mx-auto px-[18px] max-w-[1220px] py-7">
      <div className="flex flex-col md:flex-row items-center md:items-center justify-between">
        <div className="mb-6 md:mb-0 md:w-1/4">
        <div className='md:max-w-[10px]'>
          <h2 className="body-xl-27 text-white md:text-left">
            {/* Our <br /> Backers */}
            {t("our_backers")}

          </h2>
          </div>
        </div>

        <div className="w-full md:flex-1 md:ml-8 md:w-3/4">
          <Swiper
            modules={[Autoplay]}
            slidesPerView={3}
            spaceBetween={122} // Reduced to 122 to create more equal spacing
            loop={true}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
            }}
            speed={2000}
            freeMode={true}
            grabCursor={true}
          >
            {sponsors.map((sponsor) => (
              <SwiperSlide
                key={sponsor.id} // Use sponsor.id as the key for better performance
                style={{ width: 'auto' }}
                className="flex items-center justify-center min-w-[100px]"
              >
                <img
                  src={sponsor.image} // Use sponsor.image from API response
                  alt={sponsor.name} // Use sponsor.name as alt text
                  className="h-15 object-contain"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default Sponsors;
